import { useMemo } from "react"
import { getErrorMessage } from "@/utils/index"

export function useErrorMessage(errors: Array<number | null>) {
   return useMemo(() => {
      const errorNumber = errors.find((err) => err != null)
      return errorNumber ? getErrorMessage(errorNumber) : undefined
   }, [errors])
}
